import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, Divider, IconButton, Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Dashboard, EmailBody } from "../../../../../types/files";
import EmailsContentCard from "../../../../molecules/home-companies/EmailsContentCard";

const useStyles = makeStyles((theme) => ({
    dialog: {
        "& .MuiDialog-paper": {
            minWidth: 700,
            height: '100%',
            minHeight: '50vh',
            maxHeight: '70vh',
            padding: '16px 0',
            borderRadius: 24,
        }
    },
    dialogTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: '#0f172a',
        fontWeight: '600',
        fontFamily: 'Inter',
        fontSize: '1.2rem',
        padding: '0 16px',
    },
    dialogContent: {
        display: 'block',
        padding: 8,
        height: '100%',
        overflowY: 'hidden',
    },
    actionIcon: {
        height: '32px !important',
        width: '32px !important',
        padding: '0 4px !important',
    },
}));

const EmailsModal: React.FC<{
    open: boolean,
    emailActivities: EmailBody[],
    dashboard: Dashboard,
    onClose: () => void,
 }> = ({ open, dashboard, emailActivities, onClose }) => {
    const classes = useStyles();

    return (<>
        <Dialog className={classes.dialog} open={open} onClose={() => onClose()}>
            <DialogTitle className={classes.dialogTitle}>
                <Stack direction="column" alignItems="flex-start">
                    <span>{`${dashboard.title} - Emails`}</span>
                    <Typography sx={{ fontFamily: 'Lato', fontSize: '0.9rem', color: '#64748b' }}>
                        {`${emailActivities.length} email${emailActivities.length > 1 ? 's' : ''}`}
                    </Typography>
                </Stack>
                <IconButton onClick={() => onClose()} disableRipple>
                    <CloseIcon fontSize="small" sx={{ color: '#64748b' }} />
                </IconButton>
            </DialogTitle>
            <Divider sx={{ margin: '8px 0'}} />
            <DialogContent className={classes.dialogContent}>
                <EmailsContentCard emailActivities={emailActivities} />
            </DialogContent>
        </Dialog>
    </>);
}

export default EmailsModal;